// Suite action types

const suiteActionTypes = {
  SELECT_SUITE: 'SELECT_SUITE',
  CLEAR_SUITE_SELECTED: 'CLEAR_SUITE_SELECTED',
  GET_SUITE_DETAILED_AVAILABILITY_INFO: 'GET_SUITE_DETAILED_AVAILABILITY_INFO',
  GET_SUITE_DETAILED_AVAILABILITY_SUCCESS: 'GET_SUITE_DETAILED_AVAILABILITY_SUCCESS',
  GET_SUITE_DETAILED_AVAILABILITY_ERROR: 'GET_SUITE_DETAILED_AVAILABILITY_ERROR',
  GET_SUITE_DETAILED_AVAILABILITY_RESET: 'GET_SUITE_DETAILED_AVAILABILITY_RESET',
  SET_SUITE_NEW_RATES: 'SET_SUITE_NEW_RATES',
  GTM_SUITE_IMPRESSIONS: 'GTM_SUITE_IMPRESSIONS',
  SET_SUITE_PERSONALIZATION_PACKAGES: 'SET_SUITE_PERSONALIZATION_PACKAGES',
  GTM_SUITE_RATES_IMPRESSIONS: 'GTM_SUITE_RATES_IMPRESSIONS',
  UPDATE_SELECTED_SUITE_RATE_INFO: 'UPDATE_SELECTED_SUITE_RATE_INFO',
  CLEAR_LOGGED_IN_AT_SUITE_SELECTION: 'CLEAR_LOGGED_IN_AT_SUITE_SELECTION'
};

export default suiteActionTypes;
